export const billingRouteDef = [
    {
        path: 'clearance_status_billing',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: ':resource/patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
        }
    },
    {
        path: 'package',
        component: 'PackageComponent',
        data: {
            selector: 'app-package-billing'
        }
    },
    {
        path: ':resource/billingDesign/add_discount',
        component: 'DiscountComponent',
        data: {
            selector: 'app-discount'
        }
    },
    {
        path: ':discharge_patientupdate_banner/banner_change',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'discharge_patientupdate_banner'
        }
    },
    {
        path: ':banner_details_settement/banner_changes',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'banner_details_settement'
        }
    },
    {
        path: ':resource/billingDesign',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'billing_format_ip'
        }
    },
    {
        path: ':resource/billingDesignviewdetails',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'view_detail_format_ip'
        }
    },
       {
        path: ':resource/ipDesignDetails',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'view_billingdetails_tab'
        }
    },
    {
        path: ':resource/discount',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'billing_addendum_discount',
            action: 'LIST'
        }
    },
     {
        path: 'updateGuaranty',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'update_guaranteed_amount',
            action: 'ADD',
        }
    },
    {
        path: 'addendumdiscount/add',
        component: 'DiscountComponent',
        data: {
            selector: 'app-discount',
            resource: 'billing_addendum_discount',
            input: 'billing_addendum_discount',
            action: 'ADD'
        }
    },
    {
        path: 'splitDiscount/add',
        component: 'DiscountComponent',
        data: {
            selector: 'app-discount',
            resource: 'spilit_bill_detail_discount',
            input: 'spilit_bill_detail_discount',
            action: 'ADD'
        }
    },
    {
        path: ':resource/billingsettledDesign',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'settled_format_ip'
        }
    },
    {
        path: 'common_service_type_billing',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'common_service_type_billing',
            action: 'LIST'
        }
    },
    {
        path: 'viewcommon_service_type_billing',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'view_common_service_type_billing',
            action: 'LIST'
        }
    },
    {
        path: 'common_service_type_billing_addendum',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'common_service_type_billing_addendum',
            action: 'LIST'
        }
    },
    {
        path: 'viewcommon_service_type_billing_addendum',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'view_common_service_type_billing_addendum',
            action: 'LIST'
        }
    },
    {
        path: ':id/:resource/ipSettlement',
        component: 'IpSettleMentComponent',
        data: {
            selector: 'kx-ip-settle-ment',
            resource: 'billing_format_ip'
        }
    },
    {
        path: ':id/:resource/dateRangeSettlement',
        component: 'IpSettleMentComponent',
        data: {
            selector: 'kx-ip-settle-ment',
            resource: 'billing_format_ip',
            action:'dateRangeSettlement'
        }
    },
    {
        path: 'ipSettlement',
        component: 'IpSettleMentComponent',
        data: {
            selector: 'kx-ip-settle-ment',
            resource: 'billing_format_ip'
        }
    },
    {
        path: 'ipRefundPayerAuthorization',
        component: 'IpRefundPayerAuthorizationComponent',
        data: {
            selector: 'kx-ip-refund-payer-authorization',
            resource: 'settlement'
        }
    },
    {
        path: 'opbillingbill',
        component: 'IPBilling',
        data: {
            selector: 'app-ip-billing',
            action: 'createb'
        }
    },
    {
        path: 'approvebillingip',
        component: 'ApproveIpBillingComponent',
        data: {
            selector: 'kx-approve-billing-ip'
        }
    },
    {
        path: 'ipbillingbill',
        component: 'IPBilling',
        data: {
            selector: 'app-split-ip-billing',
            action: 'createb'
        }
    },
    {
        path: 'clinicalpayadvance',
        component: 'ClinicalPayAdvance',
        data: {
            selector: 'app-clinical-pay-advance',
            action: 'createb'
        }
    },
    {
        path: 'clinicalsplitbills',
        component: 'IPBilling',
        data: {
            selector: 'app-split-ip-billing',
            action: 'clinicalsplitbill'
        }
    },
    {
        path: 'dcbillingbill',
        component: 'IPBilling',
        data: {
            selector: 'app-split-ip-billing',
            action: 'createb'
        }
    },
    {
        path: 'erbillingbill',
        component: 'IPBilling',
        data: {
            selector: 'app-split-ip-billing',
            action: 'createb'
        }
    },
    {
        path: 'ip_billing_posting',
        component: 'IpBillingPostingFormComponent',
        data: {
            selector: 'app-ip-billing-posting-form',
            resource: 'billing_format_ip'
        }
    },
    {
        path: 'ip_posting_form',
        component: 'IpBillingPostingFormComponent',
        data: {
            selector: 'app-ip-billing-posting-form',
            resource: 'billing_format_ip'
        }
    }
    ,
    {
        path: 'ip_posting_form_surgery',
        component: 'IpBillingPostingFormComponent',
        data: {
            selector: 'app-ip-billing-posting-form',
            resource: 'billing_format_ip'
        }
    }
    ,
    {
        path: 'ip_posting_form_consultation',
        component: 'IpBillingPostingFormComponent',
        data: {
            selector: 'app-ip-billing-posting-form',
            resource: 'billing_format_ip'
        }
    },
    {
        path: 'doctor_wise_pending_payout',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'doctor_wise_pending_payout',
            action: 'LIST'
        }
    },
    {
        path: 'doctor_wise_completed_payout',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'doctor_wise_completed_payout',
            action: 'LIST'
        }
    },
    {
        path: 'doctor_wise_completed_payout_details',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'doctor_wise_completed_payout_details',
            action: 'LIST'
        }
    },
    {
        path: 'doctor_wise_confirmation_payout',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'doctor_wise_confirmation_payout',
            action: 'LIST'
        }
    },
    {
        path: 'doctor_wise_verified_payout',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'doctor_wise_verified_payout',
            action: 'LIST'
        }
    },
    {
        path: ':resource/bill-authorization',
        component: 'BillAuhotizationComponent',
        data: {
            selector: 'kx-bill-auhotization'
        }
    },
    {
        path: ':resource/bill-discount-amount',
        component: 'BillDiscountOverideComponent',
        data: {
            selector: 'kx-bill-discount-overide'
        }
    },
    {
        path: ':resource/orderList',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "ip_advance_payment",
        }
    },
    {
        path: 'bill_history_view',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            resource: 'bill_history_view',
            action: 'LIST',
        }
    }
]

